document.addEventListener("DOMContentLoaded", function() {
  // 获取所有包含倒计时的容器
  const countdownContainers = document.querySelectorAll('.globalcountdown[data-timer]');

  // 遍历每个倒计时容器并启动倒计时
  countdownContainers.forEach(function(container) {
    const endTime = new Date(container.getAttribute('data-timer')).getTime();
    startCountdown(container, endTime);
  });

  // 倒计时函数
  function startCountdown(element, endTime) {
    const countdownLabel = element.querySelector('.globaltext');
    const countdowntext = element.querySelector('.globallabel');
    const interval = setInterval(function() {
      const now = new Date().getTime();
      const timeLeft = endTime - now;

     if (timeLeft >= 0)  {
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        // 确保天数、小时、分钟、秒数都是两位数
        const daysStr = String(days).padStart(2, '0');
        const hoursStr = String(hours).padStart(2, '0');
        const minutesStr = String(minutes).padStart(2, '0');
        const secondsStr = String(seconds).padStart(2, '0');

        // 如果天数是 00，去掉天数显示
        if (days === 0) {
            countdowntext.textContent =`Deal End In\u00A0`;
          countdownLabel.textContent = `${hoursStr}H : ${minutesStr}M : ${secondsStr}S`;
        } else {
            countdowntext.textContent =`Deal End In\u00A0`;
          countdownLabel.textContent = `${daysStr}D : ${hoursStr}H : ${minutesStr}M : ${secondsStr}S`;
        }
      }else{
          countdownLabel.style.display = 'none';
           countdowntext.style.display = 'none';
      }
    }, 1000);
  }
});

document.addEventListener('DOMContentLoaded', function () {

    const countdownContainers = document.querySelectorAll('.bannercountdowncontainer[data-timer]');

    countdownContainers.forEach(function (container) {
      const endTime = new Date(container.getAttribute('data-timer')).getTime();
      startCountdown(container, endTime);
    });

    // 倒计时函数
    function startCountdown(element, endTime) {
      const countdownday = element.querySelector('.bannerday');
      const countdownhour = element.querySelector('.bannerhour');
      const countdownmin = element.querySelector('.bannermin');
      const countdownsec = element.querySelector('.bannersec');
      const interval = setInterval(function () {
        const now = new Date().getTime();
        const timeLeft = endTime - now;

        if (timeLeft >= 0) {
          const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
          const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

          const daysStr = String(days).padStart(2, '0');
          const hoursStr = String(hours).padStart(2, '0');
          const minutesStr = String(minutes).padStart(2, '0');
          const secondsStr = String(seconds).padStart(2, '0');

          countdownday.textContent = `${daysStr}`;
          countdownhour.textContent = `${hoursStr}`;
          countdownmin.textContent = `${minutesStr}`;
          countdownsec.textContent = `${secondsStr}`;
        } else {
          countdownContainers.style.display = 'none';
        }
      }, 1000);
    }
  });